import { environmentState } from './environmentState';

// The default luxury backdrop — always returns here unless explicitly overridden
export const DEFAULT_ENVIRONMENT = "original";


const validPresets: Record<string, string> = {
    original: 'original',
    sunset: 'sunset',
    park: 'park',
    city: 'city',
    apartment: 'apartment',
    night: 'night',
    studio: 'studio',
    warehouse: 'warehouse',
    forest: 'forest',
    dawn: 'dawn',
    lobby: 'lobby',
    penthouse: 'penthouse',
    infinitypool: 'infinityPool',
    yacht: 'yacht',
    nightlife: 'nightlife',
    privatejet: 'privateJet',
    booth: 'booth',
};

// Map generic backend hints to Luxury CDN keys
const luxuryHintMap: Record<string, string> = {
    city: 'penthouse',
    night: 'nightlife',
    park: 'infinityPool',
    water: 'yacht',
    airport: 'privateJet',
    luxury: 'penthouse'
};

const environmentVisualSettings: Record<string, { roughness: number; blur: number }> = {
    original: { roughness: 0.15, blur: 0.65 },
    penthouse: { roughness: 0.7, blur: 0.6 },
    nightlife: { roughness: 0.4, blur: 0.5 },
    yacht: { roughness: 0.5, blur: 0.4 },
    privateJet: { roughness: 0.7, blur: 0.6 },
    infinityPool: { roughness: 0.4, blur: 0.5 },
    booth: { roughness: 0.3, blur: 0.4 }
};

export const environmentController = {
    setEnvironment(hint: string) {
        const lowerHint = hint.toLowerCase();
        // Check luxury map first, then fallback to direct valid presets
        const target = luxuryHintMap[lowerHint] || validPresets[lowerHint];
        
        if (target) {
            const settings = environmentVisualSettings[target] || environmentVisualSettings.original;
            environmentState.setEnvironment(target, settings.roughness, settings.blur);
        }
    },

    resetToDefault() {
        const settings = environmentVisualSettings[DEFAULT_ENVIRONMENT];
        environmentState.setEnvironment(DEFAULT_ENVIRONMENT, settings.roughness, settings.blur);
    },

    updateEnvironment(_context: string) {
        // No-op to preserve current luxury/original feel
    }
};


// NOTE: Removed automatic voiceState subscription.
// The backdrop no longer shifts on every voice state change.

// Expose globally for manual triggering / DevTools testing
if (typeof window !== 'undefined') {
    (window as any).environmentController = environmentController;
}
